import React, { useEffect } from "react";
import NewRequestsComp from "../Components/NewRequests/NewRequests";
const NewRequests = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <NewRequestsComp />
    </div>
  );
};

export default NewRequests;
